// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"I7-z"};